import urls from "../../../../../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../../../../../utils/service";

export async function getAllDesignation(departmentId: string) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETALLDESIGNATIONBYDEPARTMENTID + departmentId,
      // urls.GETALLDESIGNATIONBYDEPARTMENTID,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addDesingation(newDesignation: any, departmentId: string) {
  const body = {
    departmentId: departmentId,
    designation_name: newDesignation.designation_name,
  };
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.ADDDESIGNATIONTODEPARTEMENTBYID, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function deleteDesignation(departmentId: string) {
  try {
    const callParams = await getCallParams("DELETE");
    const response = await makeCall(urls.DELETEDESIGNATIONBYID + departmentId, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
